export default __webpack_public_path__ + "static/media/16en.4df70407.mp3";